module.exports = __webpack_public_path__ + "assets/img/icon_expansion.cf438da8.png";